import OrderModalStock from './order-modal-stock';

export default OrderModalStock;